<div class="modal">
  <div class="header">
    <span>Resumen de operación</span>
    <div>
      <span class="separator">Total:</span>
      <span class="total">{{total | currency:'EUR':'symbol' : '0.0' : 'es'}}</span>
    </div>
  </div>
  <div class="body">
    <span>Reparto</span>
    <div class="paguitas">
      @for (reparto of paguitas; track reparto) {
        <div class="paguita">
          @if (reparto.imagen) {
            <img [src]="reparto.imagen" alt="{{reparto.nombre}}'s image" class="avatar" />
          } @else {
            <app-user-img [colorTexto]="reparto.nombre"></app-user-img>
          }
          <div class="bloque">
            <span class="nombre">{{reparto.nombre}}</span>
            <span class="message">{{reparto.message}}</span>
          </div>
          <div class="cantidad">{{reparto.cantidad | currency:'EUR':'symbol' : '0.0' : 'es'}}</div>
        </div>
      }
    </div>
  </div>
  <div class="footer">
    <button class="btn ml2 btn-cool" (click)="confirm()">Confirmar</button>
    <div class="noMostrar">
      <label class="custom-radio-checkbox">
        <input class="custom-radio-checkbox__input" type="checkbox" name="checkbox" (change)="onCheckboxChange($event)"/>
        <span class="custom-radio-checkbox__show custom-radio-checkbox__show--checkbox"></span>
        <span class="custom-radio-checkbox__text">No volver a mostrar</span>
      </label>
    </div>
  </div>
</div>